<template>
  <div>
    <div id="top" :class="{ 'search-list-page__form': !isHxForm }">
      <HxForm v-if="isHxForm" ref="hxform" is-show-fold :label-width="labelWidth" :form-item-list="formItemList"
        :form-model="formData" v-bind="hxForm" @updateFormModel="$emit('update:formData', $event)"
        @visible-change="setTableHeight()" />
      <el-form v-else ref="form" label-position="right" label-width="100px" size="small" class="hx-form" :inline="true"
        :model="formData">
        <slot :showMore="showMore"></slot>
      </el-form>
    </div>

    <div id="middle">
      <div v-if="!isHxForm && more" class="search-list-page__right">
        <el-button type="text" size="small" @click="handleMore">
          {{ moreText }}
        </el-button>
      </div>

      <el-row style="padding: 16px 0" type="flex" justify="space-between">
        <el-col :span="16">
          <el-button v-if="add" v-permission:[name]="'ADD'" size="small" @click="add">
            新增
          </el-button>
          <el-button v-if="loseApi" v-permission:[name]="'LOSE'" size="small" :disabled="loseBtnDisabled()"
            @click="handleLose">
            失效
          </el-button>
          <el-button v-if="exportApi" v-permission:[name]="'EXPORT'" size="small" @click="handleExport">
            导出
          </el-button>

          <ActionButtons type="leftButton" :action-buttons="leftButtons" :row="getSelection()" />

          <slot name="leftButton" v-bind="{}"></slot>

          <el-button v-if="typeof customColumnModule === 'number'" type="primary" size="small"
            @click="showCustomColumnDialog = true">
            自定义列设置
          </el-button>

          <span style="font-size: 14px; font-weight: 400; color: #606266">
            <slot name="leftText" :resData="resData"></slot>
          </span>
        </el-col>
        <el-col :span="8" style="text-align: right">
          <!-- <el-button size="small" type="primary" @click="handleSearch">
               搜索
               </el-button>
               <el-button size="small" @click="resetForm"> 清空 </el-button> -->
        </el-col>
      </el-row>
    </div>

    <HxTable ref="table" v-loading="tableLoading" v-bind="hxTable" :show-summary="!!sum" :summary-method="sum"
      :show-selection-col="showSelectionCol" :max-height="tableHeight" :data="tableData" :columns="tableColumnData"
      :default-column-width="defaultColumnWidth" v-on="tableListeners" @header-dragend="handleHeaderDragend">
      <template #default>
        <el-table-column v-if="showIndexCol" fixed type="index" align="center" width="56" label="序号" />

        <el-table-column v-if="showOperationColumn" fixed="right" label="操作" :width="actionColWidth">
          <template #default="{ row }">
            <ActionButtons :check="check" :modify="modify" :delete-api="deleteApi" :handle-delete="handleDelete"
              :action-buttons="actionButtons" :name="name" :row="row" />
            <slot name="actionButtons" :row="row"></slot>
          </template>
        </el-table-column>
      </template>

      <template v-for="col in defaultSlotColumns" #[col.defaultSlot]="{ row }">
        <el-link v-if="col.isLinkProp" :key="col.prop" v-permission:[col.permissionArg]="col.permissionValue"
          type="primary" :underline="false" @click="col.onClick(row)">
          {{ row[col.prop] }}
        </el-link>
        <slot v-else :name="col.defaultSlot" :row="row"></slot>
      </template>
    </HxTable>

    <!-- <HxPagination
         v-if="showPag"
         id="pagination"
         :page.sync="paginationData.page"
         :limit.sync="paginationData.limit"
         :total="paginationData.total"
         @pagination="handlePagination"
         /> -->

    <el-dialog v-if="typeof customColumnModule === 'number'" title="自定义列设置" center :visible.sync="showCustomColumnDialog"
      width="850px">
      <div style="width: 80%; margin: auto">
        <HxTransfer v-model="selectedCustomColumnData" filterable filter-placeholder="字段筛选" :titles="['隐藏字段', '显示字段']"
          :button-texts="['左移', '右移']" :props="{
            key: 'id',
            label: 'showName',
          }" :data="customColumnData" />
      </div>

      <span slot="footer">
        <el-button size="small" @click="showCustomColumnDialog = false">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="handleCustomColumnSave">
          保 存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import downloadExcel from '@/utils/downloadExcel'
import moment from 'moment/moment'
import request from '@/utils/request'
import requestv2 from '@/utils/requestv2'
import requestv3 from '@/utils/requestv3'
import ActionButtons from './action-buttons.vue'
import { permission } from '@/directives'
import mergeArrayForKey from '@/utils/mergeArrayForKey'

export default {
  name: 'HxSearchListPage',
  components: {
    ActionButtons,
  },
  directives: {
    permission,
  },
  props: {
    name: String,
    defaultColumnWidth: String,
    labelWidth: {
      type: String,
      default: '85px',
    },
    v2: {
      type: Boolean,
      default: false,
    },
    v3: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    hxForm: {
      type: Object,
      default: () => ({}),
    },
    hxTable: {
      type: Object,
      default: () => ({}),
    },
    api: {
      type: [String, Function],
      required: true,
    },
    actionButtons: {
      type: Array,
      default: () => [],
    },
    leftButtons: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    formItemList: Array,
    customColumnModule: Number,
    customColumnFindApi: {
      type: [String, Function],
      default: '/api-item/api/customizedColumns/find',
    },
    customColumnSaveApi: {
      type: [String, Function],
      default: '/api-item/api/customizedColumns/save',
    },
    exportApi: [String, Function],
    loseApi: [String, Function],
    exportFileName: [String, Function],
    deleteApi: [String, Function],
    actionColWidth: {
      type: [String, Number],
      default: 'auto',
    },
    showOperationColumn: {
      type: Boolean,
      default: true,
    },
    showSelectionCol: {
      type: Boolean,
      default: false,
    },
    showIndexCol: {
      type: Boolean,
      default: true,
    },
    linkProps: [Object, Array],
    orderNo: {
      type: Boolean,
      default: true,
    },
    applyNo: {
      type: Boolean,
      default: true,
    },
    add: Function,
    check: Function,
    modify: Function,
    more: {
      type: Boolean,
      default: true,
    },
    reqBefore: Function,
    searchResponse: Function,
    sum: Function,
    format: Object,
    showPag: {
      type: Boolean,
      default: true,
    },
    tableListeners: Object,
    isInitSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      resData: {},
      tableHeight: window.innerHeight,
      tableData: [],
      tableLoading: false,
      tableColumnData: [],
      customColumnData: [],
      selectedCustomColumnData: [],
      paginationData: {
        total: 0,
        page: 1,
        limit: 20,
      },
      showCustomColumnDialog: false,
      showMore: false,
    }
  },
  computed: {
    defaultSlotColumns() {
      return this.tableColumnData
        .map((obj) => {
          let linkProp = this.linkProps

          if (Array.isArray(this.linkProps)) {
            linkProp = this.linkProps.find((item) => item.prop === obj.prop)
          }

          if (linkProp && linkProp.prop === obj.prop) {
            obj.defaultSlot = linkProp.prop
            obj.isLinkProp = true
            obj.onClick = linkProp.onClick

            if (linkProp.permission) {
              const permissionArray = permission.split(':')
              obj.permissionArg = permissionArray[0]
              obj.permissionValue = permissionArray[1]
            }
          }

          return obj
        })
        .filter((item) => item.defaultSlot)
    },
    customPermission() {
      return {
        add: '',
        export: '',
      }
    },
    moreText() {
      return this.showMore ? '收起' : '更多'
    },
    isHxForm() {
      return !!this.formItemList
    },
    elTable() {
      return this.$refs.table.elTable
    },
    table() {
      return this.$refs.table
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    this.setTableHeight()
  },
  updated() { },
  methods: {
    handleSearch() {
      this.$emit('search')
      this.search(true)
    },
    getSelection() {
      if (this.$refs.table) {
        return this.$refs.table.selection
      }
    },

    loseBtnDisabled() {
      if (this.$refs.table && this.$refs.table.selection) {
        return !this.$refs.table.selection.length
      }

      return false
    },

    initData() {
      if (typeof this.customColumnModule === 'number') {
        this.setTableColumnData()
      } else {
        this.tableColumnData = this.columns
        if (this.isInitSearch) {
          this.search(true)
        }
      }
    },

    resetForm() {
      if (this.isHxForm) {
        this.$refs.hxform.form.resetFields()
      } else {
        this.$refs.form.resetFields()
      }

      this.$emit('fieldReset')

      this.$nextTick(() => {
        this.search(true)
      })
    },

    async search(init) {
      if (init) {
        this.paginationData.page = 1
      }

      this.tableLoading = true

      const reqConfig = {
        url: this.api,
        method: 'get',
        loading: false,
        data: {
          ...this.formData,
          ...this.reqData,
          pageNo: this.paginationData.page,
          pageNum: this.paginationData.page,
          pageSize: this.paginationData.limit,
        },
      }

      if (this.reqBefore) {
        this.reqBefore(reqConfig)
      }

      const now = +new Date()
      this.loadTime = now

      const res = await this.request(reqConfig)

      this.resData = res.data

      // 来个好心人帮忙把这里改一下吧.
      let tableData = []
      let total = 1
      if (Array.isArray(res.data)) {
        tableData = res.data
      } else if (!!res.data && "data" in res.data && Array.isArray(res.data.data) ) {
        tableData = res.data.data
      } else {
        const { list, total: _total, records, items } = res.data ? res.data : {}
        if (_total) {
          total = _total
        }
        tableData = list || records || items || []
      }

      if (tableData.length <= 0) {
        if (res.data && res.data.data && Array.isArray(res.data.data.items)) {
          this.resData = res.data.data
          tableData = res.data.data.items
          // total
        }
      }
      // ==================

      let pageCountTotal = total
      if (typeof this.searchResponse === 'function') {
        const { list, totalCount } = this.searchResponse(res)
        tableData = list
        pageCountTotal = totalCount
      }

      if (this.loadTime !== now) {
        return
      }

      this.tableData = tableData
      this.paginationData.total = pageCountTotal
      this.tableLoading = false
      this.setTableHeight()

      setTimeout(() => {
        this.$refs.table.doLayout()
      }, 200)
    },
    jumpQueue: function (arr, currentIndex, targetIndex) {
      if (!arr || arr.length === 0) return
      if (currentIndex < 0 || targetIndex < 0 || currentIndex > arr.length - 1 || targetIndex > arr.length - 1) return
      arr.splice(targetIndex, 0, arr.splice(currentIndex, 1)[0]);
      return arr;
    },
    // NOTE(d1y): 排序
    easySortTableData(currentIndex, targetIndex) {
      const data = Object.assign([], this.tableData)
      this.jumpQueue(data, currentIndex, targetIndex)
      this.tableData = data
    },
    async handleExport() {
      await this.$confirm('您是否导出当前数据为Excel？注意：这可能需要较长时间')
      const { data, headers } = await this.request({
        url: this.exportApi,
        method: 'post',
        responseType: 'blob',
        loading: true,
        data: {
          ...this.formData,
          pageNum: 1,
          pageNo: 1,
          pageSize: 10000,
        },
      })
      let name = ''
      if (typeof this.exportFileName === 'function') {
        name = this.exportFileName({ data, headers })
      } else {
        name = `${this.exportFileName}${moment(new Date()).format(
          'YYYYMMDDHHmm',
        )}.xls`
      }
      downloadExcel(name, data)
    },

    handlePagination(data) {
      this.paginationData.limit = data.limit
      this.paginationData.page = data.page
      this.search()
    },

    async handleCustomColumnSave() {
      const userModuleColumnsReqs = this.selectedCustomColumnData.map(
        (id, index) => {
          return {
            columnId: id,
            seq: index,
          }
        },
      )

      await this.request({
        url: this.customColumnSaveApi,
        method: 'post',
        data: {
          module: this.customColumnModule,
          userModuleColumnsReqs,
        },
        loading: true,
      })

      await this.setTableColumnData()
      this.showCustomColumnDialog = false
    },

    async setTableColumnData() {
      const { data } = await this.request({
        url: this.customColumnFindApi,
        method: 'post',
        data: { module: this.customColumnModule },
        loading: true,
      })

      this.customColumnData = data.hiddenColumns.concat(data.showColumns)

      this.selectedCustomColumnData = data.showColumns.map((item) => item.id)

      this.tableColumnData = data.showColumns.map((item, index) => {
        let obj = {
          // 这里使用Index为key，改变自定义列顺序才有用。使用showField无效
          key: index,
          prop: item.showField,
          label: item.showName,
        }

        if (this.format) {
          obj.format = this.format[obj.prop]
        }

        return obj
      })

      this.tableColumnData = mergeArrayForKey(
        this.tableColumnData,
        this.columns,
        'prop',
      )

      // 自定义列变动后，TABLE渲染高度有问题, 暂时这么处理
      this.tableHeight++

      setTimeout(() => {
        this.tableHeight--
      }, 100)

      if (this.isInitSearch) {
        this.search(true)
      }
    },

    handleCheck(row) {
      if (this.check) {
        this.check(row)
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm('您是否删除当前数据？')
        await this.request({
          url: this.deleteApi,
          method: 'post',
          data: row,
        })
        this.$message.success('删除成功!')
        this.search(true)
      } catch (e) { }
    },

    async handleLose(row) {
      try {
        const rows = this.getSelection()
        await this.$confirm('是否批量失效选中数据？')
        await this.request({
          url: this.loseApi,
          method: 'post',
          data: rows,
        })
        this.$message.success('删除成功!')
        this.search(true)
      } catch (e) { }
    },

    setTableHeight() {
      setTimeout(() => {
        const topHeight = document.getElementById('top').clientHeight
        let pagHeight = 0
        if (document.getElementById('pagination')) {
          pagHeight = document.getElementById('pagination').clientHeight
        }
        const middle = document.getElementById('middle').clientHeight
        this.tableHeight =
          window.innerHeight - topHeight - pagHeight - middle - 40 - 80
      }, 0)
    },

    handleMore() {
      this.showMore = !this.showMore
      this.setTableHeight()
    },

    request(config) {
      let r = request
      if (this.v2) {
        r = requestv2
      }
      if (this.v3) {
        r = requestv3
      }
      if (typeof config.url === 'function') {
        return config.url(config.data)
      } else {
        return r(config)
      }
    },

    handleHeaderDragend() {
      // 拖动后，TABLE渲染高度有问题, 暂时这么处理
      this.tableHeight++

      setTimeout(() => {
        this.tableHeight--
      }, 100)
    },
  },
}
</script>
